import React from 'react'

const HomeBlog = () => {
    return (
        <>
            <div className="container-fluid contact overflow-hidden  pb-5" style={{ marginTop: "-50px" }}>
                <div className="container py-5">
                    <div className="office pt-5">
                        <div className="section-title text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">
                            <div className="sub-style">
                                <h5 className="sub-title text-primary px-3">Shiv Travels Taxi Services</h5>
                            </div>
                            <h1 className="display-5 mb-4">Book Your Drive Now</h1>

                        </div>
                        <div className="row g-4 justify-content-center">
                            {/* <div className="col-md-6 col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.1s">
                                <div className="office-item p-4">
                                    <div className="office-img mb-4">
                                        <img src="./assets/img/ScorpioN_602x339.png" className="img-fluid w-100 rounded" alt />
                                    </div>
                                    <div className="office-content d-flex flex-column">
                                        <h4 className="mb-2">Mahindra Scorpio</h4>


                                        <div className="mb-5">

                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                Scorpio @ Rs. 15/km</p>

                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                Vehicle Color : White</p>

                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                Seating : 6 Adults + Driver</p>
                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                There are no tolls included.</p>
                                        </div>
                                    </div>
                                     <br />
                                    <a className="btn btn-primary border-secondary rounded-pill text-white py-1 px-3 wow fadeInUp" data-wow-delay="0.7s" href="tel:+91 7389578180">Book Now</a>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.1s">
                                <div className="office-item p-4">
                                    <div className="office-img mb-4">
                                        <img src="./assets/img/Innova Crysta.png" className="img-fluid w-100 rounded" alt />
                                    </div>
                                    <div className="office-content d-flex flex-column">
                                        <h4 className="mb-2">Innova Crysta</h4>


                                        <div className="mb-5">

                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                Seating : 6 Adults + Driver</p>

                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                Innova Crysta @ Rs. 18/km</p>

                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                Vehicle Color : White</p>
                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                There are no tolls included.</p>
                                        </div>
                                    </div>
                                     
                                    <a className="btn btn-primary border-secondary rounded-pill text-white py-1 px-3 wow fadeInUp" data-wow-delay="0.7s" href="tel:+91 7389578180">Book Now</a>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.1s">
                                <div className="office-item p-4">
                                    <div className="office-img mb-4">
                                        <img src="./assets/img/oyota ETIOS.png" className="img-fluid w-100 rounded" alt />
                                    </div>
                                    <div className="office-content d-flex flex-column">
                                        <h4 className="mb-2">Toyota Etios</h4>


                                        <div className="mb-5">

                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                Seating : 4 Adults + Driver</p>

                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                Toyota Etios @ Rs. 12/km</p>

                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                Vehicle Color : White</p>
                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                There are no tolls included.</p>
                                        </div>

                                    </div>
                                    <a className="btn btn-primary border-secondary rounded-pill text-white py-1 px-3 wow fadeInUp" data-wow-delay="0.7s" href="tel:+91 7389578180">Book Now</a>

                                </div>
                            </div>
                            <div className="col-md-6 col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.1s">
                                <div className="office-item p-4">
                                    <div className="office-img mb-4">
                                        <img src="./assets/img/Kia Sonet.png" className="img-fluid w-100 rounded" alt />
                                    </div>
                                    <div className="office-content d-flex flex-column">
                                        <h4 className="mb-2">Kia Sonet</h4>


                                        <div className="mb-5">

                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                Kia Sonet @ Rs. 13/km</p>

                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                Vehicle Color : White</p>

                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                Seating : 4 Adults + Driver</p>
                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                There are no tolls included.</p>
                                        </div>

                                    </div>
                                    <br />
                                    <a className="btn btn-primary border-secondary rounded-pill text-white py-1 px-3 wow fadeInUp" data-wow-delay="0.7s" href="tel:+91 7389578180">Book Now</a>

                                </div>
                            </div>
                            <div className="col-md-6 col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.1s">
                                <div className="office-item p-4">
                                    <div className="office-img mb-4">
                                        <img src="./assets/img/Maruti Ertiga.png" className="img-fluid w-100 rounded" alt />
                                    </div>
                                    <div className="office-content d-flex flex-column">
                                        <h4 className="mb-2">Maruti Ertiga</h4>


                                        <div className="mb-5">

                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                Maruti Ertiga @ Rs. 15/km</p>

                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                Vehicle Color : White</p>

                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                Seating : 6 Adults + Driver</p>
                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                There are no tolls included.</p>
                                        </div>

                                    </div>
                                    <br />
                                    <br />
                                    <a className="btn btn-primary border-secondary rounded-pill text-white py-1 px-3 wow fadeInUp" data-wow-delay="0.7s" href="tel:+91 7389578180">Book Now</a>

                                </div>
                            </div>
                            <div className="col-md-6 col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.1s">
                                <div className="office-item p-4">
                                    <div className="office-img mb-4">
                                        <img src="./assets/img/Maruti Suzuki Dzire.png" className="img-fluid w-100 rounded" alt />
                                    </div>
                                    <div className="office-content d-flex flex-column">
                                        <h4 className="mb-2">Maruti Suzuki Dzire</h4>
                                        <div className="mb-5">
                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                Swift Dzire @ Rs. 11/km</p>

                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                8 hr / 80 km @ Rs. 1800</p>

                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                Vehicle Color : White</p>
                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                Seating : 4 Adults + Drive</p>
                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                Outstation Run (Min 250km/Day)</p>
                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                There are no tolls included.</p>
                                        </div>
                                    </div>
                                    <a className="btn btn-primary border-secondary rounded-pill text-white py-1 px-3 wow fadeInUp" data-wow-delay="0.7s" href="tel:+91 7389578180">Book Now</a>

                                </div>
                            </div> */}
                            <div className="col-md-6 col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.1s">
                                <div className="office-item p-4">
                                    <div className="office-img mb-4">
                                        <img src="./assets/img/Dzire.png" className="img-fluid w-100 rounded" alt />
                                    </div>
                                    <div className="office-content d-flex flex-column">
                                        <h4 className="mb-2"> New Maruti Suzuki Dzire</h4>
                                        <div className="mb-5">
                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                Seating - 4 Adult + Driver</p>

                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                Dzire - @ 12Rs / km</p>

                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                Vehicle Colour - White</p>
                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                Toll Tax / Parkings Not  Included.</p>
                                            <br />
                                            <br />
                                        </div>
                                    </div>
                                    <a className="btn btn-primary border-secondary rounded-pill text-white py-1 px-3 wow fadeInUp" data-wow-delay="0.7s" href="tel:+91 7389578180">Book Now</a>

                                </div>
                            </div>
                            <div className="col-md-6 col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.1s">
                                <div className="office-item p-4">
                                    <div className="office-img mb-4">
                                        <img src="./assets/img/Toyota Etios.webp" className="img-fluid w-100 rounded" alt />
                                    </div>
                                    <div className="office-content d-flex flex-column">
                                        <h4 className="mb-2">Toyota Etios</h4>
                                        <div className="mb-5">
                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                Seating - 4 Adult + Driver</p>

                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                Etios - @ 12Rs/ km</p>

                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                Vehicle Colour - White</p>
                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                Toll Tax / Parkings Not  Included</p>
                                        </div>
                                    </div>
                                    <a className="btn btn-primary border-secondary rounded-pill text-white py-1 px-3 wow fadeInUp" data-wow-delay="0.7s" href="tel:+91 7389578180">Book Now</a>

                                </div>
                            </div>
                            <div className="col-md-6 col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.1s">
                                <div className="office-item p-4">
                                    <div className="office-img mb-4">
                                        <img src="./assets/img/Innova Crysta.webp" className="img-fluid w-100 rounded" alt />
                                    </div>
                                    <div className="office-content d-flex flex-column">
                                        <h4 className="mb-2">Toyota Innova Crysta</h4>
                                        <div className="mb-5">
                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                Seating - 6 Adult + Driver</p>

                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                Innova Crysta - @ 16Rs/ km</p>

                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                Vehicle Colour - White</p>
                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                Toll Tax / Parkings Not  Included</p>
                                        </div>
                                    </div>
                                    <a className="btn btn-primary border-secondary rounded-pill text-white py-1 px-3 wow fadeInUp" data-wow-delay="0.7s" href="tel:+91 7389578180">Book Now</a>

                                </div>
                            </div>
                            <div className="col-md-6 col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.1s">
                                <div className="office-item p-4">
                                    <div className="office-img mb-4">
                                        <img src="./assets/img/Maruti Ertiga.webp" className="img-fluid w-100 rounded" alt />
                                    </div>
                                    <div className="office-content d-flex flex-column">
                                        <h4 className="mb-2">Maruti Suzuki Ertiga</h4>
                                        <div className="mb-5">
                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                Seating- 6 Adult + Driver</p>

                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                New Ertiga - @ 13Rs / km</p>

                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                Vehicle Colour - White</p>
                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                Toll Tax / Parkings Not  Included</p>
                                            <br />
                                            <br />
                                            <br />
                                            <br />
                                        </div>
                                    </div>
                                    <a className="btn btn-primary border-secondary rounded-pill text-white py-1 px-3 wow fadeInUp" data-wow-delay="0.7s" href="tel:+91 7389578180">Book Now</a>

                                </div>
                            </div>
                            <div className="col-md-6 col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.1s">
                                <div className="office-item p-4">
                                    <div className="office-img mb-4">
                                        <img src="./assets/img/Bolero.png" className="img-fluid w-100 rounded" alt />
                                    </div>
                                    <div className="office-content d-flex flex-column">
                                        <h4 className="mb-2">Mahindra Bolero</h4>
                                        <div className="mb-5">
                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                Seating - 9 Adult + Driver</p>

                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                Bolero XL - @ 14Rs / km</p>

                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                Vehicle Colour - White</p>
                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                Toll Tax / Parkings Not  Included</p>
                                            <br />
                                            <br />
                                            <br />
                                        </div>
                                    </div>
                                    <a className="btn btn-primary border-secondary rounded-pill text-white py-1 px-3 wow fadeInUp" data-wow-delay="0.7s" href="tel:+91 7389578180">Book Now</a>

                                </div>
                            </div>
                            <div className="col-md-6 col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.1s">
                                <div className="office-item p-4">
                                    <div className="office-img mb-4">
                                        <img src="./assets/img/Traveller.webp" className="img-fluid w-100 rounded" alt />
                                    </div>
                                    <div className="office-content d-flex flex-column">
                                        <h4 className="mb-2">Traveller</h4>
                                        <div className="mb-5">
                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                Seating - 14 - 17 - 20 - 26  Adult + Driver</p>

                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                14(S) - @ 28Rs/km</p>

                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                17(S) - @ 30Rs/km</p>
                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                20(S) - @ 37Rs/km</p>
                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                26 (S) - @ 42Rs/km</p>
                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                Vehicle Colour - White</p>
                                            <p className="text-primary h6 mb-3"><i className="fa fa-check-circle text-secondary me-2" />
                                                Toll Tax / Parkings Not  Included</p>
                                        </div>
                                    </div>
                                    <a className="btn btn-primary border-secondary rounded-pill text-white py-1 px-3 wow fadeInUp" data-wow-delay="0.7s" href="tel:+91 7389578180">Book Now</a>

                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}

export default HomeBlog